export const fi = [
  'Tammikuu',
  'Helmikuu',
  'Maaliskuu',
  'Huhtikuu',
  'Toukokuu',
  'Kesäkuu',
  'Heinäkuu',
  'Elokuu',
  'Syyskuu',
  'Lokakuu',
  'Marraskuu',
  'Joulukuu'
]

export const en = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const sv = [
  'Januari',
  'Februari',
  'Mars',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'Augusti',
  'September',
  'Oktober',
  'November',
  'December'
]

export const localizedMonthName = (lang: 'fi' | 'en' | 'sv') => (x: number) => {
  switch (lang) {
    case 'en':
      return en[x]
    case 'sv':
      return sv[x]
    case 'fi':
      return fi[x]
    default:
      const _: never = lang
      return _
  }
}
